import { Center, Flex, Text, Box } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { TransactionType } from "@constants/types";
import { TransactionIconMapping } from "./utils";
import FooterButtons from "./components/FooterButtons";
import GainOpportunities from "@components/DepositModal/GainOpportunities";
import { POST_CLAIM_MODAL_VAULT_PROMPT } from "@constants/analytics";

interface SuccessErrorModalBodyTemplateProps {
  transactionType?: TransactionType;
  modalTitle: string;
  modalSubTitle?: string;
  extraText: string;
  onSubscribe: () => void;
  primaryBtnTxt?: string; // view transactions
  onSubmitPrimary?: () => void;
}

const ClaimELModal = ({
  primaryBtnTxt,
  transactionType,
  modalTitle,
  modalSubTitle,
  onSubscribe,
  onSubmitPrimary,
}: SuccessErrorModalBodyTemplateProps) => {
  return (
    <Center textAlign="center" flexDir="column" w="100%">
      {transactionType && (
        <BaseImage
          src={TransactionIconMapping[transactionType].icon}
          width={48}
          height={48}
          alt="icon"
        />
      )}
      <Text
        mt="1rem"
        fontSize={{
          base: "20px",
          md: "24px",
        }}
        lineHeight="28px"
      >
        {modalTitle}
      </Text>

      <Flex
        mt="0.5rem"
        fontSize="12px"
        fontWeight="400"
        textAlign="center"
        color="textSecondary"
        gap="4px"
        mb="50px"
      >
        <Text>{modalSubTitle}</Text>
      </Flex>

      <GainOpportunities
        closeModal={onSubscribe}
        action={onSubscribe}
        hasActionButton={false}
        eventName={POST_CLAIM_MODAL_VAULT_PROMPT}
      />

      {primaryBtnTxt && (
        <Box mt="24px">
          <FooterButtons
            primaryBtnTxt={primaryBtnTxt}
            onSubmitPrimary={onSubmitPrimary}
          />
        </Box>
      )}

      {/*
      <Box mt="24px" w="100%">
       <Text
          fontSize={{ base: "12px", md: "14px" }}
          fontWeight="400"
          lineHeight={{ base: "16px", md: "20px" }}
          color="textSecondary"
          mb="12px"
        >
          {extraText}
        </Text>

        <SubscribeEmail
          value={email}
          onChange={(value) => setEmail(value)}
          handleSubmit={handleSubmit}
          isDisabled={isSubscribing}
        /> 
        {error && (
          <Text textStyle="p14" color="#e53e3e" mt="0.5rem" textAlign="left">
            {error}
          </Text>
        )}
      </Box>
    */}
    </Center>
  );
};

export default ClaimELModal;
